module.exports = __webpack_public_path__ + "static/media/upload.a8a61cb9.svg";